// react
import React, { useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectShoppingCart, resetShoppingCart } from '_redux/slices/marketplace/user-marketplace';

// custom components
import ProductModal from './product-modal';
import { CustomSpinner } from '_atoms'

// styles
import { Colors, Spacing } from '_styles';

// icons
import { GoPlus } from "react-icons/go";

const ProductCard = ({ product }) => {

    // open product info modal
    const [openModal, setOpenModal] = useState(false);

    const [imageLoaded, setImageLoaded] = useState(false);


    // redux
    const dispatch = useDispatch();
    const cart = useSelector(selectShoppingCart) || {};

    // Get product details
    const {
        productTitle,
        price,
        image,
        deliveryPrice = "0.00",
        description = "No description available.",
    } = product;

    // style price
    const displayedPrice = `€${parseFloat(price).toFixed(2)}`;

    return (
        <>
            <div
                style={styles.cardWrapper}
                onClick={() => setOpenModal(true)}>

                <div style={styles.card}>

                    {/* image */}
                    <div style={styles.imageContainer}>
                        {!imageLoaded && (
                            <div style={styles.spinnerWrapper}>
                                <CustomSpinner />
                            </div>
                        )}
                        <img
                            src={image}
                            alt={productTitle}
                            style={{
                                ...styles.image,
                                display: imageLoaded ? 'block' : 'none',
                            }}
                            onLoad={() => setImageLoaded(true)}
                            onError={() => setImageLoaded(true)} // ensures spinner hides on error
                        />
                    </div>

                    {/* product title, description, price */}
                    <div style={styles.textContainer}>
                        <h3 style={styles.title}>{productTitle}</h3>

                        <div style={styles.label}>
                            <p style={styles.description}>{description}</p>
                        </div>

                        <div style={styles.priceContainer}>
                            <div style={styles.label}>
                                <span style={styles.labelValue}>{displayedPrice}</span>
                            </div>

                            {/* quantity added to cart */}
                            {cart[product?.id] ?
                                <div style={styles.quantityContainer}>
                                    <div style={styles.quantityText}>{cart[product.id].quantity}</div>
                                </div>
                                :
                                <div style={styles.quantityContainer}>
                                    <GoPlus size={22} color={'white'} />
                                </div>
                            }

                        </div>

                    </div>
                </div>
            </div>

            {/* product info + add quantity modal */}
            {openModal && (
                <div style={styles.modalOverlay}>
                    <ProductModal product={product} onClose={() => setOpenModal(false)} modalOpen={openModal} />
                </div>
            )}

        </>
    );
};

const styles = {
    cardWrapper: {

    },
    card: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: Spacing.SCALE_150,
        maxHeight: Spacing.SCALE_150,
        width: '100%',
        borderRadius: 15,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: 'white',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
        flex: 1
    },
    textContainer: {
        flex: 1.5,
        padding: Spacing.SCALE_12,
        marginTop: Spacing.SCALE_8,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        color: Colors.PRM_LIGHT_BLUE,
        fontSize: 18,
        fontWeight: 700,
        margin: 0,
    },
    label: {
        fontSize: 14,
        color: '#555',
        marginTop: Spacing.SCALE_4,
    },
    labelValue: {
        marginLeft: Spacing.SCALE_4,
        opacity: 0.8,
    },
    imageContainer: {
        flex: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: Spacing.SCALE_8,
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: 'auto',
        minHeight: 60,
        maxHeight: 160,
        objectFit: 'contain',
        borderBottomLeftRadius: 5,
        borderTopLeftRadius: 5,
    },
    spinnerWrapper: {
        width: '100%',
        minHeight: 60,
        maxHeight: 160,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        borderBottomLeftRadius: 5,
        borderTopLeftRadius: 5,
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    priceContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: -Spacing.SCALE_12
    },
    quantityContainer: {
        backgroundColor: Colors.PRM_LIGHT_BLUE,
        borderRadius: 50,
        height: 30, width: 30,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        textAlign: 'center'
    },
    quantityText: {
        color: 'white',
        fontWeight: 700,
        fontSize: 16,
        alignItems: 'center',
        textAlign: 'center'
    }
};

export default ProductCard;
